import _ from 'lodash'
import { safeAwait } from '@vzmi/component_ec_nodejs_util/dist/lib/FetchDataUtil'
import useCloneRequestController from './useCloneRequestController'
import { throwIfError } from '../../../../../lib/reserviceErrorHelpers'
import { createProposals } from '../../../../../actions/serviceActions/proposal'
import useReservice from '../../../../../hooks/useReservice'
import { getProposal } from './useProposal'
import {
  getCreateProposalPayload,
  getCustomError,
  getErrorDetailFields,
  normalizeErrorDetailPaths,
  removeProposalFields
} from '../helpers'
import { CAUSE_CODE } from '../constants'
import useCategoryAttributes from './useCategoryAttributes'

const useCreateProposal = () => {
  const { fetchWithAbort } = useCloneRequestController()
  const { reservice } = useReservice(fetchWithAbort)
  const { categoryAttributes } = useCategoryAttributes()

  const trigger = async (formValues = {}, retry = 3, updatedProposal = null) => {
    const proposalFromApi = getProposal()
    const proposal = updatedProposal || proposalFromApi
    const categoryAttrs = categoryAttributes ?? []
    const payload = getCreateProposalPayload(formValues, proposal, categoryAttrs)
    if (_.isEmpty(payload)) {
      const customError = getCustomError(CAUSE_CODE.EXTERNAL_CLONE_EMPTY_PROPOSAL_ERROR)
      throwIfError({ httpError: customError })
    }

    const [proposalError, proposalResult] = await safeAwait(
      reservice(createProposals(payload))
    )
    if (proposalError) {
      const customError = getCustomError(CAUSE_CODE.EXTERNAL_CLONE_CREATE_PROPOSAL_ERROR, proposalError)
      throwIfError({ httpError: customError })
    }

    if (proposalResult.error) {
      const errorDetailFields = getErrorDetailFields(proposalResult)
      if (_.isEmpty(errorDetailFields)) {
        return {
          proposal: null,
          error: proposalResult
        }
      }

      const normalizedPaths = normalizeErrorDetailPaths(errorDetailFields)
      const proposalPayload = _.get(proposal, 'payload', {})
      const { proposal: newProposalPayload } = removeProposalFields({ proposal: proposalPayload }, normalizedPaths)
      if (_.isEqual(proposalPayload, newProposalPayload)) {
        return {
          proposal: null,
          error: proposalResult
        }
      }

      const updatedPayloadProposal = { ...proposal, payload: newProposalPayload }
      return trigger(formValues, retry - 1, updatedPayloadProposal)
    }

    return {
      proposal: proposalResult,
      error: null
    }
  }

  return { trigger }
}

export default useCreateProposal
